import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/language/index.js'
Vue.use(VueI18n)
let locale = window.localStorage.getItem('locale') || 'zh'
let localeEN = window.localStorage.getItem('localeEN') || 'en'

const i18n = new VueI18n({
  locale, // 国际化语言
  localeEN, // 国际化语言
  messages
})

export default i18n
